const ProfilePage = () => {
  return <div className="container profile-page">Profile Page!</div>;
};

export default ProfilePage;
